(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mr-welcome"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    const dialog = document.getElementById('mr-welcome');
    if (!dialog || dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
    dialog.dataset.ready = 'true';
    const key = 'mr-welcome-raices20-v2';
    const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
    const close = () => dialog.close();
    dialog.querySelector('.mr-welcome-close').addEventListener('click', close);
    dialog.querySelector('.mr-welcome-skip').addEventListener('click', close);
    dialog.querySelector('.mr-welcome-cta').addEventListener('click', remember);
    dialog.addEventListener('close', remember);
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) close();
    });
    let seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch {}
    if (seen && !window.Shopify?.designMode) return;
    setTimeout(() => {
      if (!dialog.isConnected) return;
      if (document.querySelector('dialog[open], [role=alertdialog]')) {
        const retry = setInterval(() => {
          if (!dialog.isConnected) { clearInterval(retry); return; }
          const blocker = Array.from(document.querySelectorAll('dialog[open], [role=alertdialog]')).some(el => el !== dialog && el.getClientRects().length);
          if (!blocker) { clearInterval(retry); dialog.showModal(); remember(); }
        }, 700);
        return;
      }
      dialog.showModal();
      remember();
    }, Number(dialog.dataset.delay) * 1000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
